<template lang="html">
  <div class="header-container">
    <img :src="ativityImgSrc" class="activity" v-if="showActivity"/>
    <img src="./images/logo.png" class="logo" v-else/>
    <div class="barrage-container" ref="barrageContainer" v-if="showBarrage">
      <Barrage ref="barrage"></Barrage>
    </div>
    <img  src="./images/rule_btn.png" @click="goRule('#rule')" :class="['rule-btn',{'active-rule-btn': showActivity==true}]" clstag="jr|keycount|sqqxl_20181016|1"/>
    <div class="dongxiao">
      <div class="quan"></div>
      <div class="bg2"></div>
      <div class="quan1"></div>
      <div class="quan2"></div>
      <div class="quan3"></div>
      <div class="quan4"></div>
      <div class="jinbi1"></div>
      <div class="jinbi2" v-if="showJinbi2"></div>
      <div class="zhezhao"></div>
      <div :class="['zhudeng1',`position${headImgType}`]" v-if="showLight"></div>
      <div class="zhudeng2" v-if="showLight"></div>
      <div class="fudeng" v-if="showLight"></div>
      <div class="title" :style="{backgroundImage: 'url(\''+headImgSrc+'\')'}"></div>
    </div>
  </div>
</template>

<script>
import Barrage from "@/components/Barrage";
export default {
  name: 'Header',
  components: {
    Barrage,
  },
  props: {
    showActivity: {
      type: Boolean,
      default () {
        return false
      }
    },
    showBarrage: {
      type: Boolean,
      default () {
        return true
      }
    },
    showJinbi2: {
      type: Boolean,
      default () {
        return true
      }
    }
  },

  data () {
    return {
      headImgSrc:data_source_100001051.headImgSrc,
      headImgType:data_source_100001051.headImgType,
      ativityImgSrc:data_source_100001051.ativityImgSrc,
      showLight:false
    }
  },
  mounted(){
    setTimeout(() => {
      this.showLight = true;
    },500);
  },
  methods: {
    goRule(selector){
      //活动跳转链接
      window.location.href="https://m.jr.jd.com/mjractivity/69673-2.html";
      // var anchor = $(selector);
      // $('body,html').scrollTop(anchor[0].offsetTop);
    },
    requestBarrageData(){
      this.$refs.barrage.requestData();
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes bg-rotate
{
  0%{
      transform:rotate(0deg);
      -webkit-transform:rotate(0deg);
      -moz-transform:rotate(0deg);
      -ms-transform:rotate(0deg);
      -o-transform:rotate(0deg);
  }
  100%{
      transform:rotate(360deg);
      -webkit-transform:rotate(360deg);
      -moz-transform:rotate(360deg);
      -ms-transform:rotate(360deg);
      -o-transform:rotate(360deg);
  }
}


@keyframes bg-scale{
  0%{
      transform:scale(0);
      -webkit-transform:scale(0);
      -moz-transform:scale(0);
      -ms-transform:scale(0);
      -o-transform:scale(0);
}
  100%{
      transform:scale(1);
      -webkit-transform:scale(1);
      -moz-transform:scale(1);
      -ms-transform:scale(1);
      -o-transform:scale(1);
}
}



@keyframes quan1-go{
  0%{
    opacity: 0;
    top: 325px;
    left: 70px;
    transform: scale(0.2) translate(0,0)  ;
    -webkit-transform: scale(0.2) translate(0)  ;
    -moz-transform: scale(0.2) translate(0)  ;
    -ms-transform: scale(0.2) translate(0)  ;
    -o-transform: scale(0.2) translate(0)  ;
  }
  100%{
    opacity: 1;
    top: 335px;
    left: 10px;
    // transform: scale(1) translate(-35px,10px);
    transform: scale(1) translate(0,0);
    -webkit-transform: scale(1) translate(0,0)  ;
    -moz-transform: scale(1) translate(0,0)  ;
    -ms-transform: scale(1) translate(0,0)  ;
    -o-transform: scale(1) translate(0,0)  ;
  }
}


@keyframes quan2-go{
  0%{
    top: 190px;
    right: 170px;
    opacity: 0;
    transform: scale(0.2) translate(0,0)  ;
    -webkit-transform: scale(0.2) translate(0)  ;
    -moz-transform: scale(0.2) translate(0)  ;
    -ms-transform: scale(0.2) translate(0)  ;
    -o-transform: scale(0.2) translate(0)  ;
  }
  100%{
    opacity: 1;
    top: 250px;
    right: -10px;
    // transform: scale(1) translate(180px,60px)  ;
    transform: scale(1) translate(0,0)  ;
    -webkit-transform: scale(1) translate(0,0)  ;
    -moz-transform: scale(1) translate(0,0)  ;
    -ms-transform: scale(1) translate(0,0)  ;
    -o-transform: scale(1) translate(0,0)  ;
  }
}


@keyframes quan3-go{
  0%{
    top: 55px;
    left: 175px;
    opacity: 0;
    transform: scale(0.2) translate(0,0)  ;
    -webkit-transform: scale(0.2) translate(0)  ;
    -moz-transform: scale(0.2) translate(0)  ;
    -ms-transform: scale(0.2) translate(0)  ;
    -o-transform: scale(0.2) translate(0)  ;
  }
  100%{
    opacity: 1;
    top: 35px;
    left: 165px;
    // transform: scale(1) translate(-10px,-20px)  ;
    transform: scale(1) translate(0,0)  ;
    -webkit-transform: scale(1) translate(0,0)  ;
    -moz-transform: scale(1) translate(0,0)  ;
    -ms-transform: scale(1) translate(0,0)  ;
    -o-transform: scale(1) translate(0,0)  ;
  }
}

@keyframes quan4-go{
  0%{
    top: 85px;
    right: 185px;
    opacity: 0;
    transform: scale(0.2) translate(0,0)  ;
    -webkit-transform: scale(0.2) translate(0)  ;
    -moz-transform: scale(0.2) translate(0)  ;
    -ms-transform: scale(0.2) translate(0)  ;
    -o-transform: scale(0.2) translate(0)  ;
  }
  100%{
    opacity: 1;
    top: 45px;
    right: 125px;
    // transform: scale(1) translate(60px,-40px)  ;
    transform: scale(1) translate(0,0)  ;
    -webkit-transform: scale(1) translate(0,0)  ;
    -moz-transform: scale(1) translate(0,0)  ;
    -ms-transform: scale(1) translate(0,0)  ;
    -o-transform: scale(1) translate(0,0)  ;
  }
}


@keyframes jinbi1-go{
  0%{
    opacity: 0;
    top: 205px;
    left: 320px;
    transform: scale(0) translate(0,0)  ;
    -webkit-transform: scale(0) translate(0)  ;
    -moz-transform: scale(0) translate(0)  ;
    -ms-transform: scale(0) translate(0)  ;
    -o-transform: scale(0) translate(0)  ;
  }
  100%{
    opacity: 1;
    top: 125px;
    left: 320px;
    // transform: scale(1) translate(0,-80px)  ;
    transform: scale(1) translate(0,0)  ;
    -webkit-transform: scale(1) translate(0,0)  ;
    -moz-transform: scale(1) translate(0,0)  ;
    -ms-transform: scale(1) translate(0,0)  ;
    -o-transform: scale(1) translate(0,0)  ;
  }
}


@keyframes jinbi2-go{
  0%{
    opacity: 0;
    top: 325px;
    left: 452px;
    transform: scale(0) translate(0,0)  ;
    -webkit-transform: scale(0) translate(0)  ;
    -moz-transform: scale(0) translate(0)  ;
    -ms-transform: scale(0) translate(0)  ;
    -o-transform: scale(0) translate(0)  ;
  }
  100%{
    opacity: 1;
    top: 495px;
    left: 722px;
    // transform: scale(1) translate(270px,170px)  ;
    transform: scale(1) translate(0,0)  ;
    -webkit-transform: scale(1) translate(0,0)  ;
    -moz-transform: scale(1) translate(0,0)  ;
    -ms-transform: scale(1) translate(0,0)  ;
    -o-transform: scale(1) translate(0,0)  ;
  }
}



@keyframes deng{
  0%{
    opacity: 1;
    transform: scale(0.2);
    -webkit-transform: scale(0.2);
    -moz-transform: scale(0.2);
    -ms-transform: scale(0.2);
    -o-transform: scale(0.2);
  }
  100%{
    opacity: 0;
    transform: scale(2.5);
    -webkit-transform: scale(2.5);
    -moz-transform: scale(2.5);
    -ms-transform: scale(2.5);
    -o-transform: scale(2.5);
  }
}



@keyframes fudeng{
  0%{
    opacity: 1;
    transform: scale(0.2,1);
    -webkit-transform: scale(0.2,1);
    -moz-transform: scale(0.2,1);
    -ms-transform: scale(0.2,1);
    -o-transform: scale(0.2,1);
  }
  100%{
    opacity: 0;
    transform: scale(2);
    -webkit-transform: scale(2);
    -moz-transform: scale(2);
    -ms-transform: scale(2);
    -o-transform: scale(2);
  }
}



@keyframes head-anit{
  0%{
    opacity: 0;
    transform: scale(0);
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    -ms-transform: scale(0);
    -o-transform: scale(0);
  }
  100%{
    opacity: 1;
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
  }
}



.header-container{
  
  position: relative;
  .logo{
    width: 106px;
    height: 121px;
    position: absolute;
    left: 10px;
    top: 0;
    z-index: 999;
  }
  .barrage-container{
    position: absolute;
    left: 112px;
    top: 0;
    margin-top: 12px;
    z-index: 999;
  }
  .activity{
    position: absolute;
    width:100%;
    height: 149px;
    left: 0;
    top: 0;
    z-index: 999;
  }
  
  .rule-btn{
    position: absolute;
    right: -30px;
    top: 12px;
    width: 135px;
    height: 46px;
    display: block;
    z-index: 9998;
    &.active-rule-btn{
      top:98px;
    }
  }
  .dongxiao{
    .quan{
      width: 750px;
      height: 750px;
      background: url(./images/quan.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;

      animation: bg-scale 500ms 1 linear ;
      -webkit-animation: bg-scale 500ms 1 linear; 
      -moz-animation: bg-scale 500ms 1 linear; 
      -ms-animation: bg-scale 500ms 1 linear; 
      -o-animation: bg-scale 500ms 1 linear; 

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both; 
    }
    .bg2{
      width: 750px;
      height: 197px;
      background: url(./images/bg2.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      top: 358px;
      left: 0;
      z-index: 1;
    }
    
    .quan1{
      width: 146px;
      height: 98px;
      background: url(./images/quan1.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      // top: 325px;
      // left: 70px;
      top: 335px;
      left: 10px;
      z-index: 2;
      animation: quan1-go 500ms 1 linear 100ms;
      -webkit-animation: quan1-go 500ms 1 linear 100ms;
      -moz-animation: quan1-go 500ms 1 linear 100ms;
      -ms-animation: quan1-go 500ms 1 linear 100ms;
      -o-animation: quan1-go 500ms 1 linear 100ms;

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both; 
    }
    .quan2{
      width: 165px;
      height: 131px;
      background: url(./images/quan2.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      // top: 190px;
      // right: 170px;
      top: 250px;
      right: -10px;
      z-index: 2;

      animation: quan2-go 500ms 1 linear 300ms;
      -webkit-animation: quan2-go 500ms 1 linear 300ms;
      -moz-animation: quan2-go 500ms 1 linear 300ms;
      -ms-animation: quan2-go 500ms 1 linear 300ms;
      -o-animation: quan2-go 500ms 1 linear 300ms;

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both; 
    }
    .quan3{
      width: 137px;
      height: 151px;
      background: url(./images/quan3.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      // top: 55px;
      // left: 175px;
      top: 35px;
      left: 165px;
      z-index: 2;

      animation: quan3-go 500ms 1 linear 500ms;
      -webkit-animation: quan3-go 500ms 1 linear 500ms;
      -moz-animation: quan3-go 500ms 1 linear 500ms;
      -ms-animation: quan3-go 500ms 1 linear 500ms;
      -o-animation: quan3-go 500ms 1 linear 500ms;

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both; 
    }
    .quan4{
      width: 185px;
      height: 192px;
      background: url(./images/quan4.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      // top: 85px;
      // right: 185px;
      top: 45px;
      right: 125px;
      z-index: 2;

      animation: quan4-go 500ms 1 linear 600ms;
      -webkit-animation: quan4-go 500ms 1 linear 600ms;
      -moz-animation: quan4-go 500ms 1 linear 600ms;
      -ms-animation: quan4-go 500ms 1 linear 600ms;
      -o-animation: quan4-go 500ms 1 linear 600ms;

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both; 
    }
    .jinbi1{
      width: 33px;
      height: 40px;
      background: url(./images/jinbi1.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      // top: 205px;
      // left: 320px;
      top: 125px;
      left: 320px;
      z-index: 2;

      animation: jinbi1-go 1000ms 1 linear 200ms;
      -webkit-animation: jinbi1-go 1000ms 1 linear 200ms;
      -moz-animation: jinbi1-go 1000ms 1 linear 200ms;
      -ms-animation: jinbi1-go 1000ms 1 linear 200ms;
      -o-animation: jinbi1-go 1000ms 1 linear 200ms;

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both; 
    }
    .jinbi2{
      width: 41px;
      height: 49px;
      background: url(./images/jinbi2.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      // top: 325px;
      // left: 452px;
      top: 495px;
      left: 722px;
      z-index: 9997;

      animation: jinbi2-go 1000ms 1 linear 800ms;
      -webkit-animation: jinbi2-go 1000ms 1 linear 800ms;
      -moz-animation: jinbi2-go 1000ms 1 linear 800ms;
      -ms-animation: jinbi2-go 1000ms 1 linear 800ms;
      -o-animation: jinbi2-go 1000ms 1 linear 800ms;
      
      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both; 
    }
    .zhezhao{
      width: 100%;
      height: 1005px;
      background: url(./images/zhezhao.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      top: 0;
      right: 60px;
      z-index: 3;
      top: 0;
      left: 0;
    }
    .title{
      width: 100%;
      height: 633px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100%;
      position: absolute;
      top: -88px;
      left: 0;
      z-index: 4;

      animation: head-anit 500ms 1 linear 100ms;
      -webkit-animation: head-anit 500ms 1 linear 100ms;
      -moz-animation: head-anit 500ms 1 linear 100ms;
      -ms-animation: head-anit 500ms 1 linear 100ms;
      -o-animation: head-anit 500ms 1 linear 100ms; 

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both;
    }
    .zhudeng1{
      width: 185px;
      height: 184px;
      background: url(./images/zhudeng1.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      top: 100px;
      left: 280px;
      z-index: 5;

      animation: deng 1000ms infinite ease-out 1300ms;
      -webkit-animation: deng 1000ms infinite ease-out 1300ms;
      -moz-animation: deng 1000ms infinite ease-out 1300ms;
      -ms-animation: deng 1000ms infinite ease-out 1300ms;
      -o-animation: deng 1000ms infinite ease-out 1300ms; 

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both;

      &.position1{
        top: 90px;
        left: 230px;
      }
      &.position2{
        top: 100px;
        left: 280px;
      }
      &.position3{
        top: 75px;
        left: 190px;
      }
    }
    .zhudeng2{
      width: 145px;
      height: 144px;
      background: url(./images/zhudeng2.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      top: 235px;
      right: 130px;
      z-index: 5;

      animation: deng 1000ms infinite ease-out 1800ms;
      -webkit-animation: deng 1000ms infinite ease-out 1800ms;
      -moz-animation: deng 1000ms infinite ease-out 1800ms;
      -ms-animation: deng 1000ms infinite ease-out 1800ms;
      -o-animation: deng 1000ms infinite ease-out 1800ms; 

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both;
    }
    .fudeng{
      width: 291px;
      height: 27px;
      background: url(./images/fudeng.png) center no-repeat;
      background-size: 100%;
      position: absolute;
      top: 346px;
      left: 160px;
      z-index: 5;

      animation: fudeng 2000ms infinite ease-out 2000ms;
      -webkit-animation: fudeng 2000ms infinite ease-out 2000ms;
      -moz-animation: fudeng 2000ms infinite ease-out 2000ms;
      -ms-animation: fudeng 2000ms infinite ease-out 2000ms;
      -o-animation: fudeng 2000ms infinite ease-out 2000ms;

      animation-fill-mode: both;
      -webkit-animation-fill-mode: both;
      -moz-animation-fill-mode:  both; 
      -ms-animation-fill-mode:  both; 
      -o-animation-fill-mode:  both;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue